import assessmentTypes from '@common/constants/AssessmentTypesIds';
import { type IStudentGradeModel } from '@common/models/StudentGrades/StudentGrade';

// eslint-disable-next-line import/prefer-default-export
export const getGradeWithTitle = (grade: IStudentGradeModel, isInternational: boolean = false) => {
	const isAasL = grade.lesson.assessment_type_id === 3;

	const gradeText = isInternational
		? `${assessmentTypes[grade.lesson?.assessment_type_id]} ${grade.lesson.assessment_type_id === 2 && grade.lesson.weight ? `(${grade.lesson.weight}%)` : ''} - ${isAasL ? 'Completed' : grade.grade}`
		: grade.grade;

	const title = grade.isThematic ? grade.topic_schedule_name : grade?.grade_type?.name;

	return title ? `${gradeText} - ${title}` : gradeText;
};
